export const PAGINATION_OPTIONS = [10, 20, 50].map((value) => ({ label: String(value), value }));
